/** Expected calendar outcomes, shared by the backend and calendar clients. */
export const CalendarErrorCode = {
  NO_CALENDAR_ACCESS: 'NO_CALENDAR_ACCESS'
} as const

export type CalendarErrorCode = (typeof CalendarErrorCode)[keyof typeof CalendarErrorCode]

/** Match both the bare code and endpoint-prefixed wire codes. */
export function isNoCalendarAccessError(code: string | undefined | null): boolean {
  return typeof code === 'string' && code.endsWith(CalendarErrorCode.NO_CALENDAR_ACCESS)
}
